const ngStrExtracter = (data, address) => {
  const dataIsNested = address.includes(".");
  if (dataIsNested) {
    const allKeys = address.split(".");
    let properTxt = data;

    for (let i = 0; i < allKeys.length; i++) {
      const currentKey = allKeys[i];

      if (i === allKeys.length - 1) {
        // console.log(properTxt);
        if (Array.isArray(properTxt)) {
          // console.log("isArr the last one");
          const extractedValues = properTxt.map((item) => item[allKeys[allKeys.length - 1]]);
          return extractedValues.join(",");
        } else if (typeof properTxt[allKeys[allKeys.length - 1]] === "string") {
          return properTxt[allKeys[allKeys.length - 1]];
        } else if (properTxt[allKeys[allKeys.length - 1]] == null) {
          return " - ";
        } else {
          return "we reached an object at last";
        }
      } else {
        if (Array.isArray(properTxt)) {
          const extractedValues = properTxt.map((item) =>
            ngStrExtracter(item[currentKey], allKeys.slice(i + 1).join(".")),
          );
          return extractedValues.join(",");
        } else if (properTxt && typeof properTxt === "object" && currentKey in properTxt) {
          properTxt = properTxt[currentKey];
        } else {
          return "wrong Address , key does'nt exist";
        }
      }
    }
  } else {
    if (Array.isArray(data)) {
      const extractedValues = data.map((item) => ngStrExtracter(item, address));
      return extractedValues.join(",");
    }
    return data?.[address];
  }
};

export default ngStrExtracter;
